import image from './image.png';
import response from './response.json';
import responseToBody from '../response-to-body';

export default {
  name: 'Pré Black Friday',
  body: responseToBody(response),
  image,
};
